import React, { useState } from "react";
import { ReactComponent as HistoryIcon } from "assets/icons/history.svg";
import { ReactComponent as DollarSignIcon } from "assets/icons/dollar_sign.svg";
import { ReactComponent as NetworkWiredIcon } from "assets/icons/network_wired.svg";
import SearchPriceChangeChart from "components/Charts/SearchPriceChangeChart";
import RentalTabContent from "./RentalTabContent";
import LocationIntelligence from "./LocationIntelligence";

const TABS = [
  { id: "Storicità Annuncio", label: "Storicità Annuncio", Icon: HistoryIcon },
  { id: "Rendita Locativa", label: "Rendita Locativa", Icon: DollarSignIcon },
  {
    id: "Location Intelligence",
    label: "Location Intelligence",
    Icon: NetworkWiredIcon,
  },
];

const SearchCardMiddle = ({ property }) => {
  const [activeTab, setActiveTab] = useState(TABS[0].id);

  return (
    <div className="w-full min-h-[414px] xl:w-[35.76%] bg-white border-[1px] border-[#F0EFFB] rounded-[9px] px-[12px] pt-[9px] h-full">
      <div className="relative justify-between overflow-hidden h-[53px] rounded-[9px] bg-[#B2BCC230] py-[6px] px-[7px] flex items-center border-[0.2px] border-[#F7F7F7]">
        {TABS.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <div
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`cursor-pointer rounded-[7px] flex items-center transition-all duration-500 ease-in-out ${
                isActive
                  ? "w-auto bg-white pl-[13px] pr-[15px]"
                  : "w-[17.5%] justify-center"
              }`}
            >
              <div
                className={`w-[45px] h-[41px] rounded-[7px] transition-all duration-200 ease-in grid place-items-center ${
                  !isActive ? "hover:shadow-lg" : ""
                }`}
              >
                <tab.Icon />
              </div>
              {isActive && (
                <p className="text-[12px] flex-shrink-0 font-semibold text-black ml-[9px] transition-opacity duration-300 ease-in-out opacity-0 transform translate-x-[-10px] animate-fade-in">
                  {tab.label}
                </p>
              )}
            </div>
          );
        })}
      </div>
      {/* <LineChartIcon /> */}
      {activeTab === "Storicità Annuncio" && (
        <SearchPriceChangeChart property={property} />
      )}
      {activeTab === "Rendita Locativa" && (
        <RentalTabContent property={property} />
      )}
      {activeTab === "Location Intelligence" && (
        <LocationIntelligence property={property} />
      )}
    </div>
  );
};

export default SearchCardMiddle;
